import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * Page title block: optional mono eyebrow, the h1 (Ledger scale: 22/600),
 * optional one-line description, an `actions` slot on the right, and an
 * optional `meta` strip below (chips, dates, doc numbers).
 */
export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
  meta,
  className,
}: {
  eyebrow?: string
  title: ReactNode
  description?: ReactNode
  actions?: ReactNode
  meta?: ReactNode
  className?: string
}) {
  return (
    <header className={className}>
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          {eyebrow ? <p className="micro-label">{eyebrow}</p> : null}
          <h1
            className={cn(
              'text-[1.375rem] font-semibold tracking-wordmark text-ink',
              eyebrow && 'mt-1',
            )}
          >
            {title}
          </h1>
          {description ? <p className="mt-1.5 text-sm text-mute">{description}</p> : null}
        </div>
        {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
      </div>
      {meta ? (
        <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-2 text-[0.8125rem] text-mute">
          {meta}
        </div>
      ) : null}
    </header>
  )
}
